var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('LoadingForm'):_c('div',[_c('pre',[_vm._v(_vm._s(_vm.data))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }